import { getTranslateNsT } from "@/utils/getTranslateNsT";
import { dateFormater } from "project-config/utils/format-time";
import { ColumnsType } from "antd/es/table";
import { dateFormatter } from "project-config/utils/date-formatter";

const t = getTranslateNsT("center");

const columns: ColumnsType<any> = [
  {
    dataIndex: "billTime",
    title: t("consumption_time_selector"),
    render: (billTime) => dateFormater(billTime),
  },
  {
    dataIndex: "packName",
    title: t("user_operate_record_machine"),
  },
  {
    dataIndex: "userName",
    title: t("user_operate_record_user_name_alias"),
  },
  {
    dataIndex: "feeTime",
    title: t("consumption_pay_machine_feeTime"),
    render: (feeTime) => dateFormatter(feeTime),
  },
  {
    dataIndex: "startTime",
    title: t("consumption_pay_machine_startTime"),
    render: (startTime) => dateFormatter(startTime),
  },
  {
    dataIndex: "endTime",
    title: t("consumption_pay_machine_endTime"),
    render: (endTime) => dateFormatter(endTime),
  },
  {
    dataIndex: "nodeCount",
    title: t("consumption_pay_machine_nodeCount"),
  },
  {
    dataIndex: "feeAmount",
    title: t("consumption_pay_machine_feeAmount"),
  },
  {
    dataIndex: "platforms",
    title: t("consumption_pay_machine_platform"),
  },
];

export function useColumns() {
  return { columns };
}
